import { render, staticRenderFns } from "./LicenseBox.vue?vue&type=template&id=e7f92b50&scoped=true&lang=pug"
import script from "./LicenseBox.vue?vue&type=script&lang=js"
export * from "./LicenseBox.vue?vue&type=script&lang=js"
import style0 from "./LicenseBox.vue?vue&type=style&index=0&id=e7f92b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f92b50",
  null
  
)

export default component.exports